<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nZWIsR/tc-custom/9781466859203.jpg?1732164946034" alt="This image is the cover for the book Mrs. Big"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mrs. Big
      </h1>
      <p class="bookDescription body article font2">
        <p>Loletta Hightower likes to live <i>big</i>: exotic vacations, designer clothing, trips to the spa.  But it gets harder and harder to support her lavish lifestyle working the reception desk at a luxury car dealership. And though Loletta can con athletes, celebrities, and wealthy businessmen into taking care of her bills for a few months at a time, she wants the holy grail of every gold-digging businesswoman: the ring.<br/>When she runs into Kavon "Big" Jackson, an NBA player and former college classmate of hers, she finds it really isn't so hard to snag a high-profile husband. But it sure is hard to keep him satisfied. "Big" lives up to his name in every way, including his temper and his libido---neither of which Loletta can control. As violence and infidelity escalate in their home, so does Loletta's resolve. She's got a few surprises up her own sleeve, and the drama is just beginning.…</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Maryann Reid
      </h2>
      
      <p class="authorDescription body article"><P>Maryann Reid obtained her masters of fine arts degree from the University of Miami, has written for <I>Glamour</I> magazine, and her novella, <I>Single Black Female</I>, appeared on USAToday.com. <I>Mrs. Big</I> is her fourth book. She lives in Brooklyn, New York.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0493b419